module.exports = __webpack_public_path__ + "img/greentick.16201207.svg";